// extracted by mini-css-extract-plugin
export default {"error":"EventRoleTags_error__0yfzR"};